import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from 'src/app/services/searchService/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent implements OnInit {
  private isLoading = false;
  private offset = 0;
  private count = 20;
  results;
  constructor(private activatedRoute: ActivatedRoute, private searchService: SearchService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.offset = 0;
      this.results = new Array();
      this.isLoading = false;
      this.search();
    });
  }

  // Trigger search API
  private search() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.searchService.search({
      offset: this.offset,
      count: this.count,
      key: this.activatedRoute.snapshot.params['key']
    }).then((resp: any) => {
      this.results = this.results && this.results.length ? this.results.concat(resp.assets) : resp.assets;
      this.offset += this.count;
      this.isLoading = !resp.nextPage;
    });
  }

  // Event trigger when the user scroll to the bottom of the page
  onScroll() {
    this.search();
  }
}